// ===================================================================
// KAIXO - Resumen del panel admin
// ===================================================================
// Carga métricas reales desde /api/admin/stats/overview y muestra
// cards con números formateados.
// ===================================================================

import React, { useEffect, useState } from 'react';
import { adminStatsOverview, adminRenewSession } from '../../../services/adminApi';

function fmt(n) {
    if (n === null || n === undefined) return '—';
    if (typeof n !== 'number') return String(n);
    if (n >= 1_000_000) return (n / 1_000_000).toFixed(1) + 'M';
    if (n >= 10_000) return (n / 1_000).toFixed(1) + 'k';
    return n.toLocaleString();
}

export default function AdminOverviewSection({ me, currentUser }) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [errorStatus, setErrorStatus] = useState(0);
    const [renewing, setRenewing] = useState(false);
    const [reloadKey, setReloadKey] = useState(0);

    useEffect(() => {
        let cancelled = false;
        setLoading(true);
        setError('');
        setErrorStatus(0);
        adminStatsOverview()
            .then(({ data }) => { if (!cancelled) setData(data?.overview || null); })
            .catch(err => {
                if (cancelled) return;
                setError(err.response?.data?.error || err.message);
                setErrorStatus(err.response?.status || 0);
            })
            .finally(() => { if (!cancelled) setLoading(false); });
        return () => { cancelled = true; };
    }, [reloadKey]);

    const handleRenew = async () => {
        setRenewing(true);
        try {
            await adminRenewSession();
            setReloadKey(k => k + 1); // re-dispara la carga
        } catch (e) {
            setError('No se pudo renovar la sesión: ' + (e?.response?.data?.error || e.message));
        } finally {
            setRenewing(false);
        }
    };

    const cards = data ? [
        { label: 'Usuarios totales',       value: fmt(data.totalUsers),         sub: `+${fmt(data.usersLast30d)} en 30d` },
        { label: 'Activos hoy (DAU)',      value: fmt(data.dau),                sub: 'Engagement diario' },
        { label: 'Activos mes (MAU)',      value: fmt(data.mau),                sub: `Ratio DAU/MAU: ${data.dauMauRatio || 0}%` },
        { label: 'Mensajes hoy',           value: fmt(data.messagesToday),      sub: 'Tráfico de chat' },
        { label: 'Llamadas hoy',           value: fmt(data.callsToday),         sub: `${fmt(data.callsTotal)} totales` },
        { label: 'Latidos hoy',            value: fmt(data.postsToday),         sub: 'Publicaciones' },
        { label: 'Suscripciones activas',  value: fmt(data.activeSubscriptions),sub: `MRR: ${data.mrr ? '$' + fmt(data.mrr) : '—'}` },
        { label: 'Conversión free→pago',   value: data.conversionPct ? data.conversionPct + '%' : '—', sub: 'Eficacia del freemium' },
        { label: 'Tickets sin responder',  value: fmt(data.ticketsOpen),        sub: 'Cola de soporte' }
    ] : [];

    return (
        <div className="ap-overview">
            <div className="ap-greeting">
                Hola <strong>{currentUser?.name || 'admin'}</strong>.
                {me?.isGeneral
                    ? ' Tienes acceso completo a todas las áreas. '
                    : ' Tu acceso está limitado a las áreas asignadas. '}
                {me?.roles?.length > 0 && (
                    <span className="ap-roles-list">
                        Roles: {me.roles.join(', ')}
                    </span>
                )}
            </div>

            {loading && <div className="ap-loading">Cargando métricas…</div>}
            {error && (
                <div className="ap-error">
                    No se pudieron cargar las métricas: {error}
                    {errorStatus === 440 && (
                        <button
                            type="button"
                            className="ap-btn-renew"
                            onClick={handleRenew}
                            disabled={renewing}
                            style={{
                                marginLeft: 12,
                                background: '#ff6b35',
                                color: 'white',
                                border: 'none',
                                padding: '6px 14px',
                                borderRadius: 6,
                                fontWeight: 600,
                                cursor: renewing ? 'wait' : 'pointer',
                                fontSize: 13
                            }}
                        >
                            {renewing ? 'Renovando…' : '↻ Reanudar sesión'}
                        </button>
                    )}
                </div>
            )}

            {!loading && !error && (
                <>
                    <div className="ap-cards">
                        {cards.map(c => (
                            <div className="ap-card" key={c.label}>
                                <div className="ap-card-label">{c.label}</div>
                                <div className="ap-card-value">{c.value}</div>
                                <div className="ap-card-sub">{c.sub}</div>
                            </div>
                        ))}
                    </div>
                    {data?.generatedAt && (
                        <div className="ap-overview-hint">
                            ⓘ Datos calculados a las {new Date(data.generatedAt).toLocaleTimeString()}.
                            Cards refrescan al recargar la pestaña.
                        </div>
                    )}
                </>
            )}
        </div>
    );
}
